module.exports = __webpack_public_path__ + "img/service_2.19c37435.png";